<template>
  <input class="ui-input" :type="type" :value="modelValue ?? ''" @input="onInput" />
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    modelValue?: string | number | null;
    type?: string;
  }>(),
  {
    modelValue: "",
    type: "text",
  },
);

const emit = defineEmits<{
  "update:modelValue": [value: string];
}>();

const onInput = (event: Event): void => {
  emit("update:modelValue", (event.target as HTMLInputElement).value);
};
</script>
